export function buildCampaignState(display = {}, userAccount = {}) {
  const currentCampaign = display.currentCampaign || {};
  const client = display.client || {};
  const brand = display.brand || {};
  const dsp = display.dsp || {};
  const isProgrammatic = display.programmatic === 'programmatic';
  const isEditing = !!display.editCampaignActive;

  const customContents = display.customContents || [];
  // Only programmatic campaigns carry a target-impressions figure (sum of the
  // promised shows across every relation). Traditional campaigns send null.
  const targetImpressions = isProgrammatic
    ? customContents.reduce((sum, c) => sum + (c.promised_shows || 0), 0)
    : null;

  const campaign = {
    date_from: display.date_from || currentCampaign.start_date || null,
    date_to: display.date_to || currentCampaign.end_date || null,
    // When editing, the campaign's stored currency/country live in
    // `campaignCurrency`/`campaignInvoiceIssuingCountry`; when creating, they
    // come from the active selection (`display.currency`) and the user account
    // (`userAccount.invoiceIssuingCountry`). Mirrors BundleCardComponent.
    currency: (isEditing ? display.campaignCurrency : userAccount.currency) || null,
    // Same rule the campaign editor uses for `total_price_with_profit`:
    // programmatic → the budget the user typed; traditional → the computed sum.
    budget: isProgrammatic
      ? (display.amountBudget || display.realAmount || 0)
      : (display.realAmount || 0),
    purchase_type: isProgrammatic
      ? (display.isGuaranteed ? 'programmatic_pg' : 'programmatic')
      : 'traditional',
    // Pending while creating, or while editing a campaign whose payment is not
    // settled (`isPendingCurrentCampaign` covers pending/cancelled/rejected/…).
    status_is_pending: !isEditing || !!display.isPendingCurrentCampaign,
    target_impressions: targetImpressions,
    invoice_issuing_country:
      (isEditing ? display.campaignInvoiceIssuingCountry : userAccount.invoiceIssuingCountry) || null,
    client_id: client.id || (currentCampaign.client && currentCampaign.client.id) || null,
    brand_id: brand.id || (currentCampaign.brand && currentCampaign.brand.id) || null,
    external_dsp_id: dsp.id || null,
    selected_displays: display.cart
  };

  return {
    campaign,
  };
}

export default buildCampaignState;
